
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { send } from "../../app/appSlice"
import { AppThunkApi, RootState } from "../../app/store";
import { firstPage, Page } from "../../models/page";
import { WarningRule } from "../../models/warningRule";
import { WarningRuleDetail, WarningRulePage, WarningRuleParams } from "../../services/warningRule";
interface warningRuleState {
    warningRuleList: Page<WarningRule>,
    warningRuleDetail?: WarningRule,
}

const initialState: warningRuleState = {
    warningRuleList: firstPage(),
    warningRuleDetail: {},
};

// 分页
export const getWarningRuleListAsync = createAsyncThunk<
    Page<WarningRule>,
    WarningRuleParams,
    AppThunkApi
>("WarningRule/page", async (body, api) => {
    return send(WarningRulePage(body), api)
})

// 详情
export const getWarningRuleDetailAsync = createAsyncThunk<
    void,
    number,
    AppThunkApi
>("WarningRuleDetail/deteil", async (params, api) => {
    return send(WarningRuleDetail(params), api)
})


export const WarningRuleSlice = createSlice({
    name: "WarningRuleStation",
    initialState,
    reducers: {
        setWarningRule(state, action) {
            state.warningRuleList = action.payload;
        },
        setExceptionDetail(state, action) {
            state.warningRuleDetail = action.payload;
        },

    },
    extraReducers: (builder) => {
        builder.addCase(getWarningRuleListAsync.fulfilled, (state, action: any) => {
            state.warningRuleList = action.payload;
        })
        builder.addCase(getWarningRuleDetailAsync.fulfilled, (state, action: any) => {
            state.warningRuleDetail = action.payload;
        })
    }
});

export const { setWarningRule, setExceptionDetail } =
    WarningRuleSlice.actions;

export const selectWarningRuleList = (state: RootState) => state.warningRule.warningRuleList

export const selectWarningRuleDetail = (state: RootState) => state.warningRule.warningRuleDetail



export default WarningRuleSlice.reducer;